import { Divider, ListItemButton, Menu, Stack, Typography } from '@mui/material';
import styled from 'styled-components';

import { menuRowStyles, StyledList } from '../MenuList/index.styles';

const StyledMenu = styled(Menu)`
  && {
    & .MuiPaper-root {
      width: ${({ theme }) => theme.shape.drawerWidth}px;
      max-width: calc(100vw - ${({ theme }) => theme.spacing(2)});
      /* Below sm the menu opens from the bottom sheet, which is the width of the
         window: it spans it too, keeping only the inset its rows already sit on. */
      ${({ theme }) => theme.breakpoints.down('sm')} {
        width: calc(100vw - ${({ theme }) => theme.spacing(2)});
      }
      /* The popover seats the menu flush against the row it opens from, so it
         is lifted by the same gap that separates two nav items. */
      margin-top: -${({ theme }) => theme.spacing(1)};
      border-radius: ${({ theme }) => theme.shape.borderRadius * 2}px;
      border: 1px solid ${({ theme }) => theme.palette.divider};
      background-color: ${({ theme }) => theme.palette.background.paper};
      background-image: none;
    }
    /* The rows sit straight in the menu, so it carries the nav list's own
       spacing — tightened, a pair of actions reading closer than two
       destinations. */
    & .MuiPaper-root > .MuiList-root {
      padding: ${({ theme }) => theme.spacing(1)};
      ${menuRowStyles}

      & .MuiListItemButton-root {
        margin: ${({ theme }) => theme.spacing(0.25)} 0;
      }
    }
  }
`;

// Margins do not collapse between the drawer's flex children, so the row drops
// its own top margin to sit 8px below the list above it, as two nav items do.
const ProfileList = styled(StyledList)`
  && .MuiListItemButton-root {
    margin-top: 0;
  }
`;

const ProfileListItem = styled(ListItemButton)``;

// Left inset places the photo's centre on the icon column of the rows below it.
const Identity = styled(Stack).attrs({ direction: 'row', spacing: 2, alignItems: 'center' })`
  padding: ${({ theme }) => theme.spacing(1)} ${({ theme }) => theme.spacing(0.5)};
`;

const IdentityText = styled.div`
  min-width: 0;
`;

const Name = styled(Typography)`
  && {
    font-weight: 600;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
`;

const IdentityMessage = styled(Typography)`
  && {
    padding: ${({ theme }) => theme.spacing(1)} ${({ theme }) => theme.spacing(0.5)};
    color: ${({ theme }) => theme.palette.text.secondary};
  }
`;

// Inset to the same column as the drawer's own dividers.
const MenuDivider = styled(Divider)`
  && {
    margin: ${({ theme }) => theme.spacing(1)};
    border-color: ${({ theme }) => theme.palette.divider};
  }
`;

export {
  Identity,
  IdentityMessage,
  IdentityText,
  MenuDivider,
  Name,
  ProfileList,
  ProfileListItem,
  StyledMenu,
};
